import React from "react";

import styles from "./Icon.module.scss";

interface IProps {
    type: string;
    className?: string;
}

const Icon: React.FC<IProps> = (props) => {
  return (
    <div className={styles.Icon}>
        <div className={`${styles.inner} ${styles[props.type]} ${props.className ? ` ${props.className}` : ''}`}></div>
    </div>
  );
};

export default Icon;
